import { render, staticRenderFns } from "./addGrabAndGoGopay.vue?vue&type=template&id=6707cb0c&"
import script from "./addGrabAndGoGopay.vue?vue&type=script&lang=js&"
export * from "./addGrabAndGoGopay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports